import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";

const TESTIMONIALS = [
  {
    quote:
      "Thank you so much for always being there for me and helping me through this. You really understand me.",
    author: "Client",
    role: "Therapy Client",
  },
  {
    quote:
      "When you find a good therapist and they just get you, you know, you start to feel better.",
    author: "Client",
    role: "Therapy Client",
  },
  {
    quote:
      "Wow, I've never done therapy like that before. We've only met like four times, and wow, like you're really good. You were definitely made for this.",
    author: "Client",
    role: "Therapy Client",
  },
  {
    quote:
      "Laura is my first therapist and she's made therapy a comfortable experience for me. I wanted a therapist who I felt would be able to truly understand the things I've been through, and I feel like Laura meets what I was looking for. Excited to continue my therapy journey with Laura as my therapist.",
    author: "Client",
    role: "Therapy Client",
  },
  {
    quote:
      "Everytime I leave my sessions, I'm always like yes, she's done it again! Laura did it again!",
    author: "Client",
    role: "Therapy Client",
  },
];

const TestimonialCard = ({ testimonial }) => (
  <Card className="p-8 h-full bg-white/80 backdrop-blur-sm border-0 rounded-2xl relative">
    <div className="absolute top-4 left-6 text-5xl font-serif text-accent/50">
      &ldquo;
    </div>
    <blockquote className="relative z-10 pt-6">
      <p className="text-foreground leading-relaxed italic text-sm">
        {testimonial.quote}
      </p>
      <footer className="mt-4 pt-4 border-t border-border/30">
        <cite className="not-italic">
          <span className="font-semibold text-foreground block">
            {testimonial.author}
          </span>
          <span className="text-sm text-muted-foreground">{testimonial.role}</span>
        </cite>
      </footer>
    </blockquote>
  </Card>
);

/**
 * Shared "Stories of Healing" testimonials section — diamond layout (1-2-2).
 * Rendered on Homepage, Fees page, and DC Package page.
 */
export const StoriesOfHealing = ({ background = "bg-white" }) => (
  <section
    className={`py-24 md:py-32 px-6 md:px-12 relative ${background}`}
    data-testid="stories-of-healing"
  >
    <div className="max-w-7xl mx-auto relative">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="mb-16 text-center"
      >
        <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-foreground">
          Stories of Healing
        </h2>
        <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
          Real experiences from clients who found hope through our therapy
          programs.
        </p>
      </motion.div>

      <div className="flex flex-col items-center gap-6">
        {/* Top - 1 card */}
        <div className="w-full max-w-md">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <TestimonialCard testimonial={TESTIMONIALS[0]} />
          </motion.div>
        </div>

        {/* Middle - 2 cards */}
        <div className="w-full flex flex-col md:flex-row justify-center gap-6">
          {[1, 2].map((i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
              className="w-full md:w-[380px]"
            >
              <TestimonialCard testimonial={TESTIMONIALS[i]} />
            </motion.div>
          ))}
        </div>

        {/* Bottom - 2 cards */}
        <div className="w-full flex flex-col md:flex-row justify-center gap-6">
          {[3, 4].map((i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
              className="w-full md:w-[380px]"
            >
              <TestimonialCard testimonial={TESTIMONIALS[i]} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default StoriesOfHealing;
